export default __webpack_public_path__ + "static/media/manage-health-rec.604873ea.png";